<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <!-- Page Content -->
    <div class="content bg-white">
      <div class="container">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <!-- Register Content -->
            <div class="account-content">
              <div class="row align-items-center justify-content-center">
                <div class="col-md-7 col-lg-6 login-left">
                  <img
                    src="@/assets/img/login-banner.png"
                    class="img-fluid"
                    alt="Doccure Register"
                  />
                </div>
                <div
                  class="col-md-12 col-lg-5 login-right"
                  style="margin-top: 4%"
                >
                  <div class="login-header">
                    <h3>Registration</h3>
                  </div>

                  <!-- Register Form -->
                  <form @submit.prevent="submit_doctor">
                    <div class="input-group form-group">
                      <input
                        type="text"
                        name="first_name"
                        required=""
                        class="form-control floating"
                        v-model="register_patient.first_name"
                        placeholder="First name"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        type="text"
                        name="last_name"
                        required=""
                        class="form-control floating"
                        v-model="register_patient.last_name"
                        placeholder="Last name"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        type="text"
                        required=""
                        maxlength="10"
                        minlength="10"
                        @keypress="onlyNumber"
                        v-model="register_patient.mobile_no"
                        class="form-control floating"
                        placeholder="Mobile Number"
                      />
                    </div>
                    <div class="form-group">
                      <v-select
                        id="city"
                        placeholder="City"
                        v-model="register_patient.city"
                        :options="cities"
                        label="city"
                        :get-option-label="(option) => option.city"
                      >
                        <template #option="{ city }">
                          <div>
                            {{ city }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        v-model="register_patient.password"
                        class="form-control floating"
                        required=""
                        placeholder="Create Password"
                      />
                    </div>
                    <div class="form-group">
                      <label class="custom_check ml-2">
                        <input type="radio" name="aggrement" checked />
                        <span class="checkmark"></span> Receive relevant offers
                        and promotional communication from kneexpert
                      </label>
                      <span class="ml-4"
                        >By signing up,I agree to
                        <a style="color: #00b3d0">terms</a></span
                      >
                    </div>

                    <div class="text-right">
                      <router-link class="forgot-link" to="/login"
                        >Already have an account?</router-link
                      >
                    </div>
                    <button
                      class="btn btn-primary btn-block btn-lg login-btn"
                      type="submit"
                      :disabled="disabled"
                    >
                      Send OTP
                    </button>
                  </form>
                  <!-- /Register Form -->
                </div>
              </div>
            </div>
            <!-- /Register Content -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
export default {
  props: ["tempAppointment"],
  data() {
    return {
      cities: [],
      register_success: true,
      register_error: true,
      disabled: true,
      register_patient: {
        first_name: "",
        last_name: "",
        mobile_no: "",
        city: "",
        password: "",
      },
    };
  },
  watch: {
    register_patient: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  mounted() {
    this.get_cities();
  },
  methods: {
    indexPath() {
      this.$router.push("/doctor/index");
    },

    /* Form Validation */
    validateForm() {
      if (
        this.register_patient.city === "" ||
        this.register_patient.city === null
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },

    //Allow User to type number only
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    async get_cities() {
      this.selected_city = "";
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.cities = res.message;
      });
    },
    async submit_doctor() {
      if (this.register_patient && this.tempAppointment) {
        this.$swal({
          text: "Sending OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.register_patient.mobile_no);
        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (res.status_code == 200) {
              let data = {
                ...this.tempAppointment,
                first_name: this.register_patient.first_name,
                last_name: this.register_patient.last_name,
                mobile_no: this.register_patient.mobile_no,
                city: this.register_patient.city.city,
                password: this.register_patient.password,
              };
              this.$router.push({
                name: "enter-register-OTP",
                params: { registeration_data: data },
              });
              this.$swal.close();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.form-focus .focus-label {
  top: -18px;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/patient/Register-Booking.vue